export default class CounterpartyVatHistory {
  constructor(idInDB, counterpartyTypeId, isSubjectToVAT, rateVAT, dateOfChange) {
    this.idInDB = idInDB !== undefined ? idInDB : null;
    this.counterpartyTypeId = counterpartyTypeId;
    this.isSubjectToVAT = isSubjectToVAT;
    this.rateVAT = rateVAT;
    this.dateOfChange = dateOfChange ? new Date(dateOfChange) : null;
  }

  static createFromData(data) {
    return new CounterpartyVatHistory(
      data.idInDB,
      data.counterpartyTypeId,
      data.isSubjectToVAT,
      data.rateVAT,
      data.dateOfChange
    );
  }

  static convertToSendData(item) {
    return {
      idInDB: item.idInDB,
      counterpartyTypeId: item.counterpartyTypeId,
      isSubjectToVAT: item.isSubjectToVAT,
      rateVAT: item.rateVAT,
      dateOfChange: item.dateOfChange
    };
  }
}
